import { render, staticRenderFns } from "./teamDirectoryFooter.vue?vue&type=template&id=4a045036&scoped=true&"
var script = {}
import style0 from "./teamDirectoryFooter.vue?vue&type=style&index=0&id=4a045036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a045036",
  null
  
)

export default component.exports